<template>
  <div class="main">
    <Tabs class="tabs" :tab-list="menuList" title="账户管理" />
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuList: [
        {
          routerName: 'account/personal',
          text: '个人信息',
        },
        {
          routerName: 'account/enterprise',
          text: '企业信息',
        },
        {
          routerName: 'account/role',
          text: '角色权限',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.main {
  height: 100%;
  .box_column();
}
</style>
